import React from 'react';

export default () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.00049 3.5H11.0005C11.3983 3.5 11.7798 3.65804 12.0611 3.93934C12.3425 4.22064 12.5005 4.60218 12.5005 5V11C12.5005 11.3978 12.3425 11.7794 12.0611 12.0607C11.7798 12.342 11.3983 12.5 11.0005 12.5H5.00049C4.60266 12.5 4.22113 12.342 3.93983 12.0607C3.65852 11.7794 3.50049 11.3978 3.50049 11V5C3.50049 4.60218 3.65852 4.22064 3.93983 3.93934C4.22113 3.65804 4.60266 3.5 5.00049 3.5V3.5Z" fill="white" />
  </svg>
);
